import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=5920812e&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=5920812e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5920812e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5920812e')) {
      api.createRecord('5920812e', component.options)
    } else {
      api.reload('5920812e', component.options)
    }
    module.hot.accept("./Dashboard.vue?vue&type=template&id=5920812e&scoped=true", function () {
      api.rerender('5920812e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/Dashboard/Dashboard.vue"
export default component.exports